import { DesiredIndex, TakeFromArrayConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getTakeFromArrayTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as TakeFromArrayConfig;

	return [
		{
			id: 'collection-field',
			selector: '[data-tour="collection-field"]',
			content:
				'The collection/array field that the item will be extracted from. Only top-level collections will be displayed as available options.',
		},
		{
			id: 'desired-index',
			selector: '[data-tour="desired-index"]',
			content:
				'Determines which item from the collection should be extracted. Options include First Item, Last Item, or Nth Item. Selecting Nth Item will display the Custom Index input.',
		},
		{
			id: 'result-data',
			selector: '[data-tour="result-data"]',
			content:
				'Defines how the extracted result will appear in the task output. "Replace Source Array" replaces the collection value with the extracted item while keeping the rest of the payload unchanged. "Only Keep Extracted Value" returns only the selected collection with the extracted value in the result payload.',
		},
		...(config.desiredIndex === DesiredIndex.NthItem
			? [
					{
						id: 'custom-index',
						selector: '[data-tour="custom-index"]',
						content:
							'The one-based index of the item to extract from the collection. This field is only visible when "Nth Item" is selected as the Desired Index.',
					},
				]
			: []),
		...(config.useKeyLabel
			? [
					{
						id: 'key-label',
						selector: '[data-tour="key-label"]',
						content:
							'Defines the key label used in the result payload. This is required when "Only Keep Extracted Value" is selected and the extracted value is a primitive data type.',
					},
				]
			: []),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
